import { Button, Form, Input, message, Card, Select } from 'antd';
import axios from 'axios';
const CONN_KEY = process.env.REACT_APP_NOT_SECRET_CODE_R;
const Menugeonew = () => {

    const onFinish = async (values) => {
        try {
            const response = await axios.post(`${CONN_KEY}menuGeudata.php`, {
                Catagory: values.Catagory,
                product: values.product,
                price: values.price,
            });

            console.log(response.data);

            if (response.data.status === 1) {
                // Save Catagory as a cookie with partition key
                message.success(response.data.message);
            } else {
                message.error(response.data.message);
            }
        } catch (error) {
            console.log(error);
            // handle error
        }
    };
    const options = [
        {
            value: 'Mezeler',
        },
        {
            value: 'Zeytin yağları',
        },
        {
            value: 'Çorbalar',
        },
        {
            value: 'Salatlar',
        },
        {
            value: 'Arasıcaklar',
        },
        {
            value: 'Qarnir',
        },
        {
            value: 'Sac Yemekleri',
        },
        {
            value: 'Taş Fırın Ürünleri',
        },
        {
            value: 'Manqal porsionlar',
        },
        {
            value: 'Balıq',
        },
        {
            value: 'Fast Food',
        },
        {
            value: 'Bira Mezeleri',
        },
        {
            value: 'Desert',
        },
        {
            value: 'Sıcak İçecekler',
        },
        {
            value: 'Alkolsüz İçecekler',
        },
        {
            value: 'Taze Sıkılmış Meyve Suları',
        },
        {
            value: 'Raki',
        },
        {
            value: 'TEQUILA',
        },
        {
            value: 'viski',
        },
        {
            value: 'Vodka',
        },
        {
            value: 'Bira',
        },
        {
            value: 'Konyak & Şampanya',
        },
        {
            value: 'Likor',
        },
        {
            value: 'Gin',
        },
        {
            value: 'Şarap',
        },
        {
            value: 'Alkollü Kokteyller',
        },
        {
            value: 'Shot set',
        },
        {
            value: 'Alkolsüz Kokteyller',
        },
        {
            value: 'Shisha',
        },
        {
            value: 'Fişəng',
        },
    ];
    return (
        <Card
            title="New Product Geo"
            style={{ maxWidth: 500, }}
        >
            <Form
                name="normal_login"
                className="login-form"
                initialValues={{
                    remember: true,
                }}
                onFinish={onFinish}
            >
                <Form.Item
                    name="Catagory"
                    rules={[
                        {
                            required: true,
                            message: 'Please input your Catagory!',
                        },
                    ]}
                >
                    <Select
                        showArrow
                        // initialValues={['WHISKEY']}
                        style={{
                            width: '100%',
                        }}
                        options={options}
                        placeholder="WHISKEY"
                    />
                </Form.Item>
                <Form.Item
                    name="product"
                    rules={[
                        {
                            required: true,
                            message: 'Please input your product!',
                        },
                    ]}
                >
                    <Input
                        placeholder="product"
                    />
                </Form.Item>
                <Form.Item
                    name="price"
                    rules={[
                        {
                            required: true,
                            message: 'Please input your price!',
                        },
                    ]}
                >
                    <Input
                        placeholder="000 GEL"
                    />
                </Form.Item>
                <Form.Item>
                    <Button type="primary" htmlType="submit" className="login-form-button">
                        Add
                    </Button>
                </Form.Item>
            </Form>
        </Card>
    );
};

export default Menugeonew;
